import {Field, Formik} from 'formik';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import camelCaseToNormal from '../helpers/camelCaseToNormal';
import submitReportAndUploadPhoto from '../helpers/submitReportAndUploadFile';
import {LanguageContext} from '../LanguageContext';
import translation from '../translations';
import Option from './Dropdown/Option';
import Thumb from './Thumb';

class ManagerSubmission extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const dropdownData = require(`../data/${this.props.siteName}`);
    const isManagerIntervention = true;
    const managerCategories = require(`../data/managerCategories`);

    return (
      <LanguageContext.Consumer>
        {({lang, changeLanguage}) => {
          return (
            <div>
              <div className="bg-blue py-4 text-center">
                <h4 className="text-white text-2xl">{camelCaseToNormal(this.props.siteName)}</h4>
                <h4 className="text-white text-lg">Manager Intervention</h4>
              </div>
              <Formik
                initialValues={{
                  name: '',
                  comment: '',
                  phase: '',
                  block: '',
                  level: '',
                  category: '',
                  file: null,
                  language: lang.selected,
                }}
                onSubmit={(values, {setSubmitting, setErrors /* setValues and other goodies */}) => {
                  submitReportAndUploadPhoto(values, this.props.siteName, isManagerIntervention).then((res) => {
                    if (this.props.siteName === 'kidbrooke' || this.props.siteName === 'royalArsenal') {
                      this.props.history.push('/complete');
                    } else {
                      this.props.history.push('/complete-green-quarter-manager');
                    }
                  });
                }}
                validate={(values) => {
                  let errors = {};
                  if (!values.phase) {
                    errors.phase = 'required';
                  } else if (
                    ((this.props.siteName === 'southall' && values.phase === 'Phase A') ||
                      (this.props.siteName === 'royalArsenal' && values.phase !== 'RAR Site Wide') ||
                      (this.props.siteName === 'kidbrooke' &&
                        values.phase !== 'Site Wide' &&
                        values.phase !== 'Phase 2 West') ||
                      (this.props.siteName === 'greenQuarter' &&
                        values.phase !== 'Site Wide' &&
                        values.phase !== 'Sales & Marketing' &&
                        values.phase !== 'Linear Park' &&
                        values.phase !== 'Eastern Access') ||
                      (this.props.siteName === 'highcroft' &&
                        values.phase !== 'Phase 1A' &&
                        values.phase !== 'Phase 1B')) &&
                    !values.block
                  ) {
                    errors.block = 'required';
                  }
                  return errors;
                }}
                render={({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <form className="px-4 pt-4" onSubmit={handleSubmit}>
                    <label htmlFor="name" className="block text-grey-darker text-sm font-bold mb-2">
                      {translation.submission[lang.selected].NAME}
                    </label>
                    <input
                      id="name"
                      type="text"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.name && touched.name
                          ? 'text-input error'
                          : 'shadow appearance-none border rounded w-full py-2 px-3 mb-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline'
                      }
                    />
                    <div className="w-full">
                      <label htmlFor="name" className="block text-grey-darker text-sm font-bold mb-2">
                        Category
                      </label>
                      <Field
                        className="w-full shadow appearance-none border rounded w-5/6 py-2 px-3 mb-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                        component="select"
                        name="category"
                      >
                        {[''].concat(managerCategories.manager.categories).map((category, i) => (
                          <Option key={i} value={category} />
                        ))}
                      </Field>
                    </div>
                    <label htmlFor="name" className="block text-grey-darker text-sm font-bold mb-2">
                      {translation.submission[lang.selected].PHASE}
                    </label>
                    {errors.phase && touched.phase && <p className="text-red  text-sm italic">{errors.phase}</p>}
                    <Field
                      className="hadow appearance-none border rounded w-full py-2 px-3 mb-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                      component="select"
                      name="phase"
                    >
                      {[''].concat(Object.keys(dropdownData)).map((phase, i) => (
                        <Option key={i} value={phase} />
                      ))}
                    </Field>
                    <div className="flex">
                      <div className="w-full">
                        <label htmlFor="name" className="block text-grey-darker text-sm font-bold mb-2">
                          {translation.submission[lang.selected].BLOCK}
                        </label>
                        {errors.block && touched.block && <p className="text-red  text-sm italic">{errors.block}</p>}
                        <Field
                          className="hadow appearance-none border rounded w-5/6 py-2 px-3 mb-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                          component="select"
                          name="block"
                        >
                          {values.phase &&
                            ['']
                              .concat(Object.keys(dropdownData[values.phase]))
                              .map((block, i) => <Option key={i} value={block} />)}
                        </Field>
                      </div>
                      <div className="w-full text-right">
                        <label htmlFor="name" className="block text-grey-darker text-sm font-bold mb-2">
                          {translation.submission[lang.selected].LEVEL}
                        </label>
                        {errors.level && touched.level && <p className="text-red  text-sm italic">{errors.level}</p>}
                        <Field
                          className="hadow appearance-none border rounded w-5/6 py-2 px-3 mb-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                          component="select"
                          name="level"
                        >
                          {values.phase &&
                            values.block &&
                            ['']
                              .concat(dropdownData[values.phase][values.block])
                              .map((level, i) => <Option key={i} value={level} />)}
                        </Field>
                      </div>
                    </div>
                    <label htmlFor="comment" className="block text-grey-darker text-sm font-bold mb-2">
                      {translation.submission[lang.selected].COMMENT}
                    </label>
                    <textarea
                      id="comment"
                      placeholder={translation.submission[lang.selected].COMMENT_PLACEHOLDER}
                      type="text"
                      value={values.comment}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.comment && touched.comment
                          ? 'text-input error'
                          : 'shadow appearance-none border rounded w-full py-2 px-3 mb-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline'
                      }
                    />

                    {errors.file && touched.file && <p className="text-red text-sm italic">{errors.file}</p>}
                    <input
                      id="file"
                      name="file"
                      type="file"
                      className="w-full text-blue font-semibold py-2 px-4 border border-blue rounded"
                      onChange={(event) => {
                        setFieldValue('file', event.currentTarget.files[0]);
                      }}
                    />
                    <Thumb file={values.file} />
                    <div className="text-center py-4">
                      <button
                        className="no-underline bg-blue hover:bg-blue text-white font-bold py-2 px-4 rounded"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {translation.submission[lang.selected].SUBMIT}
                      </button>
                    </div>
                  </form>
                )}
              />
            </div>
          );
        }}
      </LanguageContext.Consumer>
    );
  }
}
export default withRouter(ManagerSubmission);



// WEBPACK FOOTER //
// ./src/components/ManagerSubmission.js